<template src="../templates/milkInspection.pug" lang="pug"></template>

<script>
import MilkInspectionForm from './form/MilkInspectionForm'
import AnimalCard from './card/AnimalCard'
import FilterState from './filter/FilterState'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { format, parse } from 'date-fns'
import _filter from 'lodash/filter'
import _each from 'lodash/each'
import _map from 'lodash/map'
import _find from 'lodash/find'
import _countBy from 'lodash/countBy'
import $axios from '../axios'

export default {
    name: 'MilkInspection',
    components: {
        FilterState,
        MilkInspectionForm,
        AnimalCard
    },
    data() {
        return {
            selectedAnimal: null,
            showMilkInspectionForm: false,
            milkInspectionToUpdate: {
                id: null,
                milkingDate: null,
                results: []
            },
            milkResultsToUpdate: [],
            searchInput: '',
            milkResultHovered: null,
            milkResultOnEdit: null,
            milkResultOnEditVal: null,
            milkResultOnCreate: null,
            milkResultOnCreateVal: null,
            format
        }
    },
    computed: {
        ...mapGetters([
            'animals',
            'selectedFarm',
            'filteredMilkInspectionAnimals',
            'isUserVisitor',
            'isColumnOrdered'
        ]),
        filteredAnimals() {
            if (this.searchInput.length > 0) {
                let self = this
                return _filter(this.animals, function(a) {
                    let str = a.buckleNumber.toString()
                    return str.includes(self.searchInput)
                })
            } else {
                return this.filteredMilkInspectionAnimals
            }
        }
    },
    created() {
        this.$store.commit('resetTableOrder')
        this.$store.commit('resetFilterState')
        this.$store.commit('resetFilterCowType')
        this.$store.commit('updateFilterCowType', 'cow')
    },
    methods: {
        ...mapMutations(['updateTableOrder']),
        ...mapActions(['deleteInspection']),
        getMilkResults(milkResults) {
            let milkResultsArray = []
            let index = 0
            _each(this.selectedFarm.milkInspections, function(mi) {
                if (index < 7) {
                    let result = _find(milkResults, function(mr) {
                        return mr.date === mi.date
                    })
                    milkResultsArray.push(result !== undefined ? result : null)
                }
                index++
            })
            return milkResultsArray
        },
        setMilkResultOnEdit(mr) {
            if (mr !== null) {
                this.milkResultOnEdit = mr.id
                this.milkResultOnEditVal = mr.total
            } else {
                this.milkResultOnEdit = null
                this.milkResultOnEditVal = null
            }
        },
        editMilkResult(animal, mr) {
            $axios
                .post('/api/milkinspection/editresult/' + animal + '/' + mr, {
                    total: this.milkResultOnEditVal
                })
                .then(response => {
                    this.$store.commit('updateAnimal', response.data)
                })
            this.resetEditLive()
        },
        createMilkResult(animal, mi) {
            $axios
                .post('/api/milkinspection/createresult/' + animal + '/' + mi, {
                    total: this.milkResultOnCreateVal
                })
                .then(response => {
                    this.$store.commit('updateAnimal', response.data)
                })
            this.resetEditLive()
        },
        setMilkInspectionsOnEdit(mi) {
            let milkResultsToUpdate = _map(this.filteredMilkInspectionAnimals, function(a) {
                let milkResult = {
                    animalId: a.id,
                    buckleNumber: a.buckleNumber,
                    resultId: null,
                    first: null,
                    second: null,
                    third: null,
                    total: null
                }
                let result = _find(a.milkResults, function(mr) {
                    return mr.date === mi.date
                })
                if (result !== undefined) {
                    milkResult.resultId = result.resultId
                    milkResult.first = result.first
                    milkResult.second = result.second
                    milkResult.third = result.third
                    milkResult.total = result.total
                }
                return milkResult
            })
            this.$router.push({
                name: 'edit-inspection-form',
                params: {
                    inspectionId: mi.id,
                    milkResultsToUpdate: milkResultsToUpdate,
                    milkInspectionToUpdate: mi
                }
            })
            this.milkInspectionToUpdate = mi
            this.showMilkInspectionForm = true
        },
        resetEditLive() {
            this.milkResultHovered = null
            this.milkResultOnEdit = null
            this.milkResultOnEditVal = null
            this.milkResultOnCreate = null
            this.milkResultOnCreateVal = null
        },
        deleteInspectionDialog(milkInspection) {
            this.$dialog
                .confirm(
                    this.$t('milk.dialog.message', {
                        date: format(new Date(milkInspection.date * 1000), 'DD/MM/YY')
                    }),
                    {
                        okText: this.$t('button.true'),
                        cancelText: this.$t('button.false')
                    }
                )
                .then(() => {
                    this.deleteInspection([this.selectedFarm.id, milkInspection.id])
                })
                .catch(() => {})
        }
    }
}
</script>

<style lang="sass" scoped>
    @import '../sass/mixin/color'
    @import '../sass/mixin/flex'

    #milk-inspection
        .filter-container
            .flex-grow-1
                @include flexbox
                @include flex-direction(row)
                @include justify-content(flex-end)
        .content
            .button-row
                .round-button-effect
                    padding: 1em
                    .round-button-icon
                        fill: $dd-very-dark-gray
                        box-shadow: 0 0 0 4px $dd-very-dark-gray
                    &:hover
                        svg
                            background: $dd-very-dark-gray none repeat scroll 0 0
                            fill: white
            table
                .table-header
                    background-color: $dd-very-dark-gray
                .cell-buckle-number
                    cursor: pointer
                    &:hover
                        font-size: 18px
                        font-weight: bold
                        color: $dd-light-orange
                .milk-result-container, .milk-result-edit-container, .milk-result-create-container
                    position: relative
                    @include flex-center
                    @include flex-direction(row)
                    .block-action
                        z-index: 10000
                        cursor: pointer
                        position: absolute
                        @include flex-center
                        right: 0
                .milk-result-edit-container, .milk-result-create-container
                    input
                        max-width: 68px
                    .block-action
                        &:nth-child(2)
                            right: -24px
                        &:last-child
                            background-color: white
                            right: -48px
                .milk-result-empty-container
                    min-width: 100%
                    min-height: 40px
                    @include flex-center


</style>
